import React from 'react'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { IssueLabel } from '../../../../components/entities/IssueLabel'
import { ConvertibleLabel } from '../../../../components/entities/ConvertibleLabel'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { IssuesGroupEntity } from 'types/IssuesGroupEntity'

export function IssueGroups({
    entity,
    entitiesInGroups,
    handleDeleteFromGroup,
    handleAddToGroup,
    isGuarantorFeeIssue,
}: {
    entity: { id: string }
    handleAddToGroup: (groupId: string) => void
    handleDeleteFromGroup: (groupId: string) => void
    entitiesInGroups: Record<string, Array<IssuesGroupEntity>>
    isGuarantorFeeIssue: boolean
}) {
    return (
        <>
            <Typography variant='body2'>Länkgrupper</Typography>
            <List>
                {Object.entries(entitiesInGroups)
                    .filter(([, entites]) => {
                        if (!isGuarantorFeeIssue) return true

                        return entites.some((e) => e.issueId === entity.id)
                    })
                    .map(([groupId, entities]) => {
                        const isInGroup = entities.some((e) => e.issueId === entity.id || e.convertibleId === entity.id)
                        return (
                            <ListItem key={groupId} sx={{ border: 'dotted 1px', borderRadius: 3 }}>
                                <Stack direction='column' spacing={1}>
                                    {!isInGroup && (
                                        <Tooltip title='Lägg till i gruppen'>
                                            <IconButton onClick={() => handleAddToGroup(groupId)}>
                                                <AddCircleOutlineIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    {isInGroup && (
                                        <Tooltip title='Ta bort från gruppen'>
                                            <IconButton onClick={() => handleDeleteFromGroup(groupId)}>
                                                <RemoveCircleOutlineIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Stack>
                                <List>
                                    {entities.map((e) => (
                                        <ListItem key={`${groupId}_${e.issueId || e.convertibleId}`}>
                                            {e.issueId ? (
                                                <Typography variant='body2'>
                                                    <IssueLabel adminLink issue={e} />{' '}
                                                    {entity.id === e.issueId && ' (aktuell emission)'}
                                                </Typography>
                                            ) : null}
                                            {e.convertibleId ? (
                                                <Typography variant='body2'>
                                                    <ConvertibleLabel
                                                        adminLink
                                                        convertible={{ ...e, id: e.convertibleId }}
                                                    />{' '}
                                                    {entity.id === e.convertibleId && ' (aktuell konvertibel)'}
                                                </Typography>
                                            ) : null}
                                        </ListItem>
                                    ))}
                                </List>
                            </ListItem>
                        )
                    })}
            </List>
        </>
    )
}
